<style scoped>
.loading-page {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 10rem;
	opacity: 0.1;
}
</style>

<script>
import vSelect from "vue-select";

export default {
	name: "Loading",
	props: ["type"],

	data() {
		return {};
	},
	created() {},
	watch: {},

	render(h) {
		switch (this.type) {
			case "icon":
				return this.loadingIcon(h);
			case "header":
				return <div>Loading...&nbsp;{this.loadingIcon(h)}</div>;
			case "inline-header":
				return <span>Loading...&nbsp;{this.loadingIcon(h)}</span>;
			case "table":
				return (
					<div class="text-center my-2">
						Loading...&nbsp;{this.loadingIcon(h)}
					</div>
				);
			case "large":
				return this.loadingLarge(h);
			case "page":
				return <div class="loading-page">{this.loadingIcon(h)}</div>;
		}
	},
	methods: {
		loadingIcon(h) {
			return <i class="fas fa-spinner-third fa-spin" />;
		},
		loadingLarge(h) {
			return <div class="loading-large">{this.loadingIcon(h)}</div>;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/global/Loading.vue